<dialog-draggable-header>Create a Duplicate TPR</dialog-draggable-header>

<mat-dialog-content>
    <b>Please enter a unique Checking Fixture Number below:</b>

    <mat-divider></mat-divider>

    <mat-form-field class="w-100">
        <input matInput minLength="1" maxLength="20" floatLabel="always" placeholder="New Fixture Number"
            [formControl]="newFixtureNo" />
        <mat-error *ngIf="this.newFixtureNo.hasError('pattern')">
            Only a-z, A-Z, 0-9, -, and _ are allowed.
        </mat-error>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="mat-dialog-actions-end no-margin">
    <button mat-raised-button color="primary" [disabled]="!newFixtureNo.valid || loading" (click)="duplicateTpr()">
        Continue
    </button>
    <button mat-raised-button mat-dialog-close [disabled]="loading">Cancel</button>
</mat-dialog-actions>